import { TFunction } from 'i18next'
import {
  dateToSlashString,
  dateToSlashStringReinterpretedAsLocal,
} from '../../../../utils/dateUtility'
import getLocaleCurrencyForAmount from '../../../../utils/getLocaleCurrencyForAmount'
import { Payment } from '../../../Interfaces/Payment'

export const getLcdLicensingPaymentHistoryRows = (
  t: TFunction,
  paymentHistory: Payment[]
): Payment[] => {
  const rows: Payment[] = paymentHistory.map((payment) => {
    return {
      ...payment,
      date: dateToSlashString(payment.begunAt, true),
      program: `${payment.licensingPayment?.programType ?? ''} (${
        payment.licensingPayment?.semesterOneStartDate
          ? dateToSlashStringReinterpretedAsLocal(
              payment.licensingPayment?.semesterOneStartDate as Date
            )
          : ''
      })`,
      paymentAmount: getLocaleCurrencyForAmount(
        payment.amount.amount,
        payment.amount.currencyCode
      ),
      communityName: payment.licensingPayment?.communityName,
      communityId: payment.licensingPayment?.communityKey,
      acumaticaOrderNumber: payment.orderId,
    }
  })

  return rows
}
